import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAlien8bit,
  faArrowDownAZ,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowDownZA,
  faArrowLeft,
  faArrowUpRightFromSquare,
  faArrowsFromLine,
  faArrowsToLine,
  faBan,
  faBookOpenCover,
  faBooks,
  faBoxArchive,
  faBoxOpen,
  faBuilding,
  faCalendarClock,
  faCalendarDays,
  faCamera,
  faChalkboardUser,
  faChartLineDown,
  faChartLineUp,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faCircleNodes,
  faCircleUser,
  faDownload,
  faEdit,
  faFaceLaughBeam,
  faFile,
  faFileCertificate,
  faFileCheck,
  faFileDoc,
  faFileExport,
  faFilePdf,
  faFileSpreadsheet,
  faFilter,
  faFolder,
  faGauge,
  faGear,
  faHand,
  faHeadSideGoggles,
  faHiking,
  faImage,
  faKey,
  faLayerGroup,
  faLink,
  faList,
  faMagnifyingGlass,
  faMedal,
  faMoneyCheckDollarPen,
  faMountain,
  faOtter,
  faPaperPlane,
  faPencil,
  faPenField,
  faPersonChalkboard,
  faPersonRunning,
  faPlus,
  faPresentationScreen,
  faQuestionCircle,
  faRobot,
  faRotate,
  faScreenUsers,
  faSignsPost,
  faSitemap,
  faSlashForward,
  faSliders,
  faSwap,
  faTicket,
  faTrashCan,
  faUpload,
  faUser,
  faUserGear,
  faUserHardHat,
  faUserHeadset,
  faUserLock,
  faUserPlus,
  faUserXmark,
  faUsers,
  faUsersGear,
  faVideo,
  faVrCardboard,
  faXmark,
} from "@fortawesome/pro-light-svg-icons";

export function initLightIcons() {
  library.add(
    faAlien8bit,
    faArrowDownAZ,
    faArrowDownShortWide,
    faArrowDownWideShort,
    faArrowDownZA,
    faArrowLeft,
    faArrowUpRightFromSquare,
    faArrowsFromLine,
    faArrowsToLine,
    faBan,
    faBookOpenCover,
    faBooks,
    faBoxArchive,
    faBoxOpen,
    faBuilding,
    faCalendarClock,
    faCalendarDays,
    faCamera,
    faChalkboardUser,
    faChartLineDown,
    faChartLineUp,
    faChevronDown,
    faChevronRight,
    faCircle,
    faCircleInfo,
    faCircleNodes,
    faCircleUser,
    faDownload,
    faEdit,
    faFaceLaughBeam,
    faFile,
    faFileCertificate,
    faFileCheck,
    faFileDoc,
    faFileExport,
    faFilePdf,
    faFileSpreadsheet,
    faFilter,
    faFolder,
    faGauge,
    faGear,
    faHand,
    faHeadSideGoggles,
    faHiking,
    faImage,
    faKey,
    faLayerGroup,
    faLink,
    faList,
    faMagnifyingGlass,
    faMedal,
    faMoneyCheckDollarPen,
    faMountain,
    faOtter,
    faPaperPlane,
    faPencil,
    faPenField,
    faPersonChalkboard,
    faPersonRunning,
    faPlus,
    faPresentationScreen,
    faQuestionCircle,
    faRobot,
    faRotate,
    faScreenUsers,
    faSignsPost,
    faSitemap,
    faSlashForward,
    faSliders,
    faSwap,
    faTicket,
    faTrashCan,
    faUpload,
    faUser,
    faUserGear,
    faUserHardHat,
    faUserHeadset,
    faUserLock,
    faUserPlus,
    faUserXmark,
    faUsers,
    faUsersGear,
    faVideo,
    faVrCardboard,
    faXmark
  );
}
